// extracted by mini-css-extract-plugin
export default {"error":"MyForm_error__IO+FN"};